import { PropsWithChildren } from 'react';
import { useTrackMobileBookingFlowContext } from '../../../hooks/useTrackMobileBookingFlowContext';
import { BookingFlowNextButtonProps } from '../Common/BookingFlowBottomBar';
import { BookingFlowScreen, BookingFlowScreenLayoutProps } from '../Common/BookingFlowScreen';
import { BookingValidationVariant } from './BookingValidationModal';
import { CarglassInfoBanner } from './CarglassInfoBanner';
import { FixedBookingScreenBottomBar } from './FixedBookingScreenBottomBar';
import { PublicAnnouncement } from './PublicAnnouncement';

type Props = BookingFlowScreenLayoutProps &
  BookingFlowNextButtonProps & {
    hideShoppingCart?: boolean;
    showSelectedCars?: boolean;
    showSelectedTimeWindow?: boolean;
    validationVariant?: BookingValidationVariant;
  };

export const BookingScreen = ({
  children,
  onNextClicked,
  disableNextButton,
  hideNextButton,
  nextButtonLoading,
  hideShoppingCart,
  showSelectedCars,
  showSelectedTimeWindow,
  validationVariant = 'stepIncomplete',
  ...layoutProps
}: PropsWithChildren<Props>) => {
  useTrackMobileBookingFlowContext();

  return (
    <BookingFlowScreen
      {...layoutProps}
      beforeHeader={
        <>
          <PublicAnnouncement />
          <CarglassInfoBanner />
        </>
      }
      defaultBottomBar={
        <FixedBookingScreenBottomBar
          hideBackButton={layoutProps.hideBackButton}
          onNextClicked={onNextClicked}
          disableNextButton={disableNextButton}
          hideNextButton={hideNextButton}
          nextButtonLoading={nextButtonLoading}
          hideShoppingCart={hideShoppingCart}
          showSelectedCars={showSelectedCars}
          showSelectedTimeWindow={showSelectedTimeWindow}
          validationVariant={validationVariant}
        />
      }
    >
      {children}
    </BookingFlowScreen>
  );
};
